import React, { useState, useEffect, useCallback } from 'react';
import InvoiceCreator from "./components/InvoiceCreator";
import LegalSearch from "./components/LegalSearch";
import AADESettings from "./AADESettings";
import DocGenerator from "./components/DocGenerator";
import ConflictCheck from "./components/ConflictCheck";
import AIInsights from "./components/AIInsights";
import DataImport from "./components/DataImport";
import Syntaxi from './components/Syntaxi';
import './components/Syntaxi.css';

const CRMDashboard = ({ onLogout, user }) => {
  const isPremium = user && (user.plan === 'premium' || user.plan === 'professional' || user.plan === 'enterprise' || user.plan === 'law_firm');
  const premiumTabs = ['dashboard', 'clients', 'cases', 'deadlines', 'hours', 'invoices', 'aade', 'conflicts', 'import'];
  // ==================== STATE ====================
  const [activeTab, setActiveTab] = useState('nomologia');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [trialDays, setTrialDays] = useState(14);
  const [isTrial, setIsTrial] = useState(false);
  const [showTrialUpgrade, setShowTrialUpgrade] = useState(false);

  // Dashboard data
  const [stats, setStats] = useState({
    totalClients: 0,
    activeCases: 0,
    upcomingDeadlines: 0,
    monthlyHours: 0,
  });

  // Clients
  const [clients, setClients] = useState([]);
  const [showClientModal, setShowClientModal] = useState(false);
  const [currentClient, setCurrentClient] = useState(null);
  const [clientForm, setClientForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    mobile: '',
    company: '',
    afm: '',
    amka: '',
    doy: '',
    idNumber: '',
    birthDate: '',
    profession: '',
    address: '',
    city: '',
    zip: '',
    previousLawyer: '',
    referralSource: '',
    notes: '',
  });
  const [clientFilter, setClientFilter] = useState('');

  // Cases
  const [cases, setCases] = useState([]);
  const [showCaseModal, setShowCaseModal] = useState(false);
  const [currentCase, setCurrentCase] = useState(null);
  const [caseForm, setCaseForm] = useState({
    title: '',
    description: '',
    clientId: '',
    caseType: '',
    status: 'Open',
    caseNumber: '',
    protocolNumber: '',
    opponentName: '',
    opponentAfm: '',
    opponentLawyer: '',
    court: '',
    filingDate: '',
    nextHearing: '',
    disputeValue: '',
    fee: '',
    billingType: 'fixed',
    priority: 'normal',
    notes: '',
  });
  const [caseFilter, setCaseFilter] = useState('');

  // Deadlines
  const [deadlines, setDeadlines] = useState([]);
  const [showDeadlineModal, setShowDeadlineModal] = useState(false);
  const [currentDeadline, setCurrentDeadline] = useState(null);
  const [deadlineForm, setDeadlineForm] = useState({
    title: '',
    description: '',
    dueDate: '',
    dueTime: '',
    caseId: '',
    deadlineType: '',
    court: '',
    priority: 'Normal',
    status: 'Pending',
    reminder: '3days',
    notes: '',
  });

  // Hours
  const [hours, setHours] = useState([]);
  const [showHourModal, setShowHourModal] = useState(false);
  const [currentHour, setCurrentHour] = useState(null);
  const [hourForm, setHourForm] = useState({
    caseId: '',
    clientId: '',
    date: new Date().toISOString().split('T')[0],
    startTime: '',
    endTime: '',
    hours: '',
    activityType: '',
    description: '',
    hourlyRate: '',
    billable: true,
    notes: '',
  });

  // Invoices
  const [invoices, setInvoices] = useState([]);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [currentInvoice, setCurrentInvoice] = useState(null);
  const [invoiceForm, setInvoiceForm] = useState({
    clientId: '',
    caseId: '',
    invoiceNumber: '',
    issueDate: new Date().toISOString().split('T')[0],
    dueDate: '',
    subtotal: '',
    vatRate: '24',
    vatAmount: '',
    amount: '',
    paymentMethod: '',
    status: 'Draft',
    description: '',
    items: '',
    notes: '',
  });

  // Documents
  const [documents, setDocuments] = useState([]);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [documentForm, setDocumentForm] = useState({
    name: '',
    caseId: '',
    file: null,
  });

  // Case Law Search
  const [caseSearchQuery, setCaseSearchQuery] = useState('');
  const [caseSearchResults, setCaseSearchResults] = useState([]);
  const [caseSearchLoading, setCaseSearchLoading] = useState(false);

  // AI Insights
  const [aiInsights, setAiInsights] = useState([]);
  const [aiLoading, setAiLoading] = useState(false);

  // Conflict Check
  const [conflictCheckQuery, setConflictCheckQuery] = useState('');
  const [conflictResults, setConflictResults] = useState(null);
  const [conflictLoading, setConflictLoading] = useState(false);

  const token = localStorage.getItem('token') || localStorage.getItem('nomokratia_token');
  useEffect(() => {
    window.__nkBillingModal = () => new Promise((resolve) => {
      const ov = document.createElement('div');
      ov.style.cssText = 'position:fixed;inset:0;background:rgba(15,23,42,.55);z-index:99999;display:flex;align-items:center;justify-content:center;padding:16px;';
      const box = document.createElement('div');
      box.style.cssText = 'background:#fff;border-radius:16px;max-width:460px;width:100%;padding:24px;box-shadow:0 20px 60px rgba(0,0,0,.3);font-family:system-ui,sans-serif;max-height:92vh;overflow-y:auto;';
      const F = (id,label,ph,req)=>`<div style="margin-bottom:12px"><label style="display:block;font-size:13px;font-weight:600;color:#334155;margin-bottom:4px">${label}${req?' *':''}</label><input id="${id}" placeholder="${ph||''}" style="width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #CBD5E1;border-radius:8px;font-size:14px"/></div>`;
      box.innerHTML =
        '<div style="font-size:18px;font-weight:800;color:#1E293B;margin-bottom:4px">Στοιχεία Τιμολόγησης</div>'+
        '<div style="font-size:13px;color:#64748B;margin-bottom:16px">Απαιτούνται για την έκδοση του τιμολογίου σας.</div>'+
        F('nk_name','Ονοματεπώνυμο / Επωνυμία','',true)+
        F('nk_vat','ΑΦΜ','9 ψηφία',true)+
        F('nk_doy','ΔΟΥ','π.χ. Δ Αθηνών',true)+
        F('nk_addr','Διεύθυνση','Οδός, Αριθμός',true)+
        F('nk_city','Πόλη','',true)+
        F('nk_zip','ΤΚ','',true)+
        F('nk_phone','Τηλέφωνο','(προαιρετικό)',false)+
        '<div id="nk_err" style="color:#DC2626;font-size:13px;margin:8px 0;min-height:16px"></div>'+
        '<div style="display:flex;gap:10px;margin-top:8px">'+
        '<button id="nk_cancel" style="flex:1;padding:11px;border:1px solid #CBD5E1;background:#fff;border-radius:8px;font-weight:600;cursor:pointer">Άκυρο</button>'+
        '<button id="nk_ok" style="flex:2;padding:11px;border:none;background:#1e3a5f;color:#fff;border-radius:8px;font-weight:700;cursor:pointer">Αποθήκευση & Πληρωμή</button>'+
        '</div>';
      ov.appendChild(box); document.body.appendChild(ov);
      const close = (val)=>{ try{document.body.removeChild(ov);}catch(e){} resolve(val); };
      box.querySelector('#nk_cancel').onclick = ()=>close(null);
      ov.onclick = (e)=>{ if(e.target===ov) close(null); };
      box.querySelector('#nk_ok').onclick = ()=>{
        const g=(id)=>(document.getElementById(id).value||'').trim();
        const name=g('nk_name'), vat=g('nk_vat'), doy=g('nk_doy'), addr=g('nk_addr'), city=g('nk_city'), zip_=g('nk_zip'), phone=g('nk_phone');
        const err=document.getElementById('nk_err');
        if(!name||!doy||!addr||!city||!zip_){ err.textContent='Συμπληρώστε όλα τα υποχρεωτικά πεδία.'; return; }
        if(!/^[0-9]{9}$/.test(vat)){ err.textContent='Μη έγκυρο ΑΦΜ (9 ψηφία).'; return; }
        close({billing_name:name, vat_number:vat, doy:doy, office_address:addr, office_city:city, office_zip:zip_, phone:phone});
      };
    });
  }, []);
  useEffect(() => { if (window.location.href.includes('payment=success')) { try { window.history.replaceState(null, '', window.location.href.replace(/[?&]payment=success/, '')); } catch(e){} setTimeout(() => window.location.reload(), 2000); } }, []);

  const getHeaders = useCallback(() => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  }), [token]);

  // ==================== UTILITY FUNCTIONS ====================

  const handleError = (err) => {
    console.error(err);
    setError(err.message || 'Ένα σφάλμα προέκυψε');
    setTimeout(() => setError(null), 5000);
  };

  const fetchTrialStatus = useCallback(async () => {
    try {
      const res = await fetch('/api/crm/trial-status', {
        headers: getHeaders(),
      });
      if (res.ok) {
        const data = await res.json();
        setTrialDays(data.days_left ?? 14); setIsTrial(!!data.is_trial);
      }
    } catch (err) {
      console.error('Trial status error:', err);
    }
  }, [getHeaders]);

  // ==================== DASHBOARD ====================

  const fetchStats = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch('/api/crm/dashboard/stats', {
        headers: getHeaders(),
      });
      if (res.ok) {
        const data = await res.json();
        setStats(data);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  }, [getHeaders]);

  // ==================== CLIENTS ====================

  const fetchClients = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch('/api/crm/clients', {
        headers: getHeaders(),
      });
      if (res.ok) {
        const data = await res.json();
        setClients(Array.isArray(data) ? data : data.clients || []);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  }, [getHeaders]);

  const handleSaveClient = async () => {
    try {
      setLoading(true);
      const method = currentClient ? 'PUT' : 'POST';
      const url = currentClient ? `/api/crm/clients/${currentClient.id}` : '/api/crm/clients';

      const res = await fetch(url, {
        method,
        headers: getHeaders(),
        body: JSON.stringify(clientForm),
      });

      if (res.ok) {
        await fetchClients();
        setShowClientModal(false);
        setClientForm({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          mobile: '',
          company: '',
          afm: '',
          amka: '',
          doy: '',
          idNumber: '',
          birthDate: '',
          profession: '',
          address: '',
          city: '',
          zip: '',
          previousLawyer: '',
          referralSource: '',
          notes: '',
        });
        setCurrentClient(null);
      } else {
        const error = await res.json();
        handleError(new Error(error.message || 'Σφάλμα κατά την αποθήκευση'));
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClient = async (id) => {
    if (!window.confirm('Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον πελάτη;')) {
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`/api/crm/clients/${id}`, {
        method: 'DELETE',
        headers: getHeaders(),
      });

      if (res.ok) {
        await fetchClients();
      } else {
        handleError(new Error('Σφάλμα κατά την διαγραφή'));
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const openClientModal = (client = null) => {
    if (client) {
      setCurrentClient(client);
      setClientForm(client);
    } else {
      setCurrentClient(null);
      setClientForm({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        mobile: '',
        company: '',
        afm: '',
        amka: '',
        doy: '',
        idNumber: '',
        birthDate: '',
        profession: '',
        address: '',
        city: '',
        zip: '',
        previousLawyer: '',
        referralSource: '',
        notes: '',
      });
    }
    setShowClientModal(true);
  };

  // ==================== CASES ====================

  const fetchCases = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch('/api/crm/cases', {
        headers: getHeaders(),
      });
      if (res.ok) {
        const data = await res.json();
        setCases(Array.isArray(data) ? data : data.cases || []);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  }, [getHeaders]);

  const handleSaveCase = async () => {
    try {
      setLoading(true);
      const method = currentCase ? 'PUT' : 'POST';
      const url = currentCase ? `/api/crm/cases/${currentCase.id}` : '/api/crm/cases';

      const res = await fetch(url, {
        method,
        headers: getHeaders(),
        body: JSON.stringify(caseForm),
      });

      if (res.ok) {
        await fetchCases();
        setShowCaseModal(false);
        setCaseForm({
          title: '',
          description: '',
          clientId: '',
          caseType: '',
          status: 'Open',
          caseNumber: '',
        });
        setCurrentCase(null);
      } else {
        const error = await res.json();
        handleError(new Error(error.message || 'Σφάλμα κατά την αποθήκευση'));
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCase = async (id) => {
    if (!window.confirm('Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την υπόθεση;')) {
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`/api/crm/cases/${id}`, {
        method: 'DELETE',
        headers: getHeaders(),
      });

      if (res.ok) {
        await fetchCases();
      } else {
        handleError(new Error('Σφάλμα κατά την διαγραφή'));
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const openCaseModal = (caseItem = null) => {
    if (caseItem) {
      setCurrentCase(caseItem);
      setCaseForm(caseItem);
    } else {
      setCurrentCase(null);
      setCaseForm({
        title: '',
        description: '',
        clientId: '',
        caseType: '',
        status: 'Open',
        caseNumber: '',
      });
    }
    setShowCaseModal(true);
  };

  // ==================== DEADLINES ====================

  const fetchDeadlines = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch('/api/crm/deadlines', {
        headers: getHeaders(),
      });
      if (res.ok) {
        const data = await res.json();
        setDeadlines(Array.isArray(data) ? data : data.deadlines || []);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  }, [getHeaders]);

  const handleSaveDeadline = async () => {
    try {
      setLoading(true);
      const method = currentDeadline ? 'PUT' : 'POST';
      const url = currentDeadline ? `/api/crm/deadlines/${currentDeadline.id}` : '/api/crm/deadlines';

      const res = await fetch(url, {
        method,
        headers: getHeaders(),
        body: JSON.stringify(deadlineForm),
      });

      if (res.ok) {
        await fetchDeadlines();
        setShowDeadlineModal(false);
        setDeadlineForm({
          title: '',
          description: '',
          dueDate: '',
          caseId: '',
          priority: 'Normal',
          status: 'Pending',
        });
        setCurrentDeadline(null);
      } else {
        const error = await res.json();
        handleError(new Error(error.message || 'Σφάλμα κατά την αποθήκευση'));
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteDeadline = async (id) => {
    if (!window.confirm('Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την προθεσμία;')) {
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`/api/crm/deadlines/${id}`, {
        method: 'DELETE',
        headers: getHeaders(),
      });

      if (res.ok) {
        await fetchDeadlines();
      } else {
        handleError(new Error('Σφάλμα κατά την διαγραφή'));
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const openDeadlineModal = (deadline = null) => {
    if (deadline) {
      setCurrentDeadline(deadline);
      setDeadlineForm(deadline);
    } else {
      setCurrentDeadline(null);
      setDeadlineForm({
        title: '',
        description: '',
        dueDate: '',
        caseId: '',
        priority: 'Normal',
        status: 'Pending',
      });
    }
    setShowDeadlineModal(true);
  };

  // ==================== HOURS ====================

  const fetchHours = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch('/api/crm/hours', {
        headers: getHeaders(),
      });
      if (res.ok) {
        const data = await res.json();
        setHours(Array.isArray(data) ? data : data.hours || []);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  }, [getHeaders]);

  const handleSaveHour = async () => {
    try {
      setLoading(true);
      const method = currentHour ? 'PUT' : 'POST';
      const url = currentHour ? `/api/crm/hours/${currentHour.id}` : '/api/crm/hours';

      const res = await fetch(url, {
        method,
        headers: getHeaders(),
        body: JSON.stringify(hourForm),
      });

      if (res.ok) {
        await fetchHours();
        setShowHourModal(false);
        setHourForm({
          caseId: '',
          date: new Date().toISOString().split('T')[0],
          hours: '',
          description: '',
          billable: true,
        });
        setCurrentHour(null);
      } else {
        const error = await res.json();
        handleError(new Error(error.message || 'Σφάλμα κατά την αποθήκευση'));
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteHour = async (id) => {
    if (!window.confirm('Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την καταγραφή ωρών;')) {
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`/api/crm/hours/${id}`, {
        method: 'DELETE',
        headers: getHeaders(),
      });

      if (res.ok) {
        await fetchHours();
      } else {
        handleError(new Error('Σφάλμα κατά την διαγραφή'));
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const openHourModal = (hour = null) => {
    if (hour) {
      setCurrentHour(hour);
      setHourForm(hour);
    } else {
      setCurrentHour(null);
      setHourForm({
        caseId: '',
        date: new Date().toISOString().split('T')[0],
        hours: '',
        description: '',
        billable: true,
      });
    }
    setShowHourModal(true);
  };

  // ==================== INVOICES ====================

  const fetchInvoices = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch('/api/crm/invoices', {
        headers: getHeaders(),
      });
      if (res.ok) {
        const data = await res.json();
        setInvoices(Array.isArray(data) ? data : data.invoices || []);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  }, [getHeaders]);

  const handleSaveInvoice = async () => {
    try {
      setLoading(true);
      const method = currentInvoice ? 'PUT' : 'POST';
      const url = currentInvoice ? `/api/crm/invoices/${currentInvoice.id}` : '/api/crm/invoices';

      const res = await fetch(url, {
        method,
        headers: getHeaders(),
        body: JSON.stringify(invoiceForm),
      });

      if (res.ok) {
        await fetchInvoices();
        setShowInvoiceModal(false);
        setInvoiceForm({
          clientId: '',
          amount: '',
          invoiceNumber: '',
          dueDate: '',
          status: 'Draft',
          description: '',
        });
        setCurrentInvoice(null);
      } else {
        const error = await res.json();
        handleError(new Error(error.message || 'Σφάλμα κατά την αποθήκευση'));
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteInvoice = async (id) => {
    if (!window.confirm('Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το τιμολόγιο;')) {
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`/api/crm/invoices/${id}`, {
        method: 'DELETE',
        headers: getHeaders(),
      });

      if (res.ok) {
        await fetchInvoices();
      } else {
        handleError(new Error('Σφάλμα κατά την διαγραφή'));
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const openInvoiceModal = (invoice = null) => {
    if (invoice) {
      setCurrentInvoice(invoice);
      setInvoiceForm(invoice);
    } else {
      setCurrentInvoice(null);
      setInvoiceForm({
        clientId: '',
        amount: '',
        invoiceNumber: '',
        dueDate: '',
        status: 'Draft',
        description: '',
      });
    }
    setShowInvoiceModal(true);
  };

  // ==================== DOCUMENTS ====================

  const fetchDocuments = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch('/api/crm/documents', {
        headers: getHeaders(),
      });
      if (res.ok) {
        const data = await res.json();
        setDocuments(Array.isArray(data) ? data : []);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  }, [getHeaders]);

  const handleSaveDocument = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('name', documentForm.name);
      formData.append('caseId', documentForm.caseId);
      if (documentForm.file) {
        formData.append('file', documentForm.file);
      }

      const res = await fetch('/api/crm/documents', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData,
      });

      if (res.ok) {
        await fetchDocuments();
        setShowDocumentModal(false);
        setDocumentForm({ name: '', caseId: '', file: null });
      } else {
        const error = await res.json();
        handleError(new Error(error.message || 'Σφάλμα κατά την αποθήκευση'));
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteDocument = async (id) => {
    if (!window.confirm('Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το έγγραφο;')) {
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(`/api/crm/documents/${id}`, {
        method: 'DELETE',
        headers: getHeaders(),
      });

      if (res.ok) {
        await fetchDocuments();
      } else {
        handleError(new Error('Σφάλμα κατά την διαγραφή'));
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };

  // ==================== CASE LAW SEARCH ====================

  const handleCaseSearch = async () => {
    if (!caseSearchQuery.trim()) return;

    try {
      setCaseSearchLoading(true);
      const res = await fetch(`/api/crm/nomologia/search?q=${encodeURIComponent(caseSearchQuery)}`, {
        headers: getHeaders(),
      });

      if (res.ok) {
        const data = await res.json();
        setCaseSearchResults(Array.isArray(data) ? data : []);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setCaseSearchLoading(false);
    }
  };

  // ==================== AI INSIGHTS ====================

  const handleGenerateInsights = async () => {
    try {
      setAiLoading(true);
      const res = await fetch('/api/crm/ai/insights', {
        method: 'POST',
        headers: getHeaders(),
      });

      if (res.ok) {
        const data = await res.json();
        setAiInsights(Array.isArray(data) ? data : []);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setAiLoading(false);
    }
  };

  // ==================== CONFLICT CHECK ====================

  const handleConflictCheck = async () => {
    if (!conflictCheckQuery.trim()) return;

    try {
      setConflictLoading(true);
      const res = await fetch('/api/crm/conflicts/check', {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ query: conflictCheckQuery }),
      });

      if (res.ok) {
        const data = await res.json();
        setConflictResults(data);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setConflictLoading(false);
    }
  };

  // ==================== LOGOUT ====================

  const handleLogout = async () => {
    try {
      await fetch('/api/auth/logout', {
        method: 'POST',
        headers: getHeaders(),
      });
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      localStorage.removeItem('token');
      onLogout();
    }
  };

  // ==================== EFFECTS ====================

  useEffect(() => {
    fetchTrialStatus();
    if (activeTab === 'dashboard') {
      fetchStats();
    } else if (activeTab === 'clients') {
      fetchClients();
    } else if (activeTab === 'cases') {
      fetchCases();
    } else if (activeTab === 'deadlines') {
      fetchDeadlines();
    } else if (activeTab === 'hours') {
      fetchHours();
    } else if (activeTab === 'invoices') {
      fetchInvoices();
    } else if (activeTab === 'documents') {
      fetchDocuments();
    } else if (activeTab === 'ai') {
      handleGenerateInsights();
    }
  }, [activeTab]);

  // ==================== STYLES ====================

  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#f7fafc',
      fontFamily: 'system-ui, -apple-system, sans-serif',
    },
    trialBanner: {
      background: 'linear-gradient(135deg, #1a365d 0%, #2c5282 100%)',
      color: 'white',
      padding: '8px 24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: '13px',
      letterSpacing: '0.3px',
    },
    trialText: {
      flex: 1,
      opacity: 0.9,
    },
    upgradeBtn: {
      backgroundColor: '#38a169',
      color: 'white',
      border: 'none',
      padding: '8px 20px',
      borderRadius: '6px',
      cursor: 'pointer',
      fontWeight: '600',
      fontSize: '13px',
      marginRight: '10px',
      boxShadow: '0 2px 4px rgba(56,161,105,0.3)',
      transition: 'all 0.2s',
    },
    header: {
      backgroundColor: 'white',
      padding: '14px 24px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #e2e8f0',
    },
    headerTitle: {
      fontSize: '22px',
      fontWeight: 'bold',
      color: '#1a365d',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    logoutBtn: {
      backgroundColor: '#1e3a5f',
      color: 'white',
      border: 'none',
      padding: '8px 18px',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '13px',
      fontWeight: '500',
      transition: 'all 0.2s',
    },
    quickActions: {
      backgroundColor: '#f7fafc',
      padding: '20px',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '10px',
    },
    actionBtn: {
      background: 'linear-gradient(135deg, #1e3a5f, #2c5282)',
      color: 'white',
      border: 'none',
      padding: '14px 20px',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '600',
      boxShadow: '0 2px 4px rgba(0,0,0,0.12)',
      transition: 'all 0.2s',
    },
    tabBar: {
      backgroundColor: 'white',
      borderBottom: '2px solid #e2e8f0',
      display: 'flex',
      overflowX: 'auto',
      padding: '0 20px',
    },
    tab: {
      padding: '12px 20px',
      cursor: 'pointer',
      borderBottom: '3px solid transparent',
      fontSize: '14px',
      fontWeight: '500',
      whiteSpace: 'nowrap',
      color: '#4a5568',
      transition: 'all 0.3s',
    },
    tabActive: {
      color: '#2b6cb0',
      borderBottomColor: '#2b6cb0',
    },
    content: {
      padding: '20px',
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '20px',
      marginBottom: '20px',
    },
    statCard: {
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
    },
    statValue: {
      fontSize: '32px',
      fontWeight: 'bold',
      color: '#2b6cb0',
      marginBottom: '5px',
    },
    statLabel: {
      fontSize: '14px',
      color: '#4a5568',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      backgroundColor: 'white',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    },
    th: {
      backgroundColor: '#f7fafc',
      padding: '12px',
      textAlign: 'left',
      fontWeight: '600',
      color: '#1a365d',
      borderBottom: '2px solid #e2e8f0',
    },
    td: {
      padding: '12px',
      borderBottom: '1px solid #e2e8f0',
    },
    actionCell: {
      display: 'flex',
      gap: '8px',
    },
    editBtn: {
      backgroundColor: '#2b6cb0',
      color: 'white',
      border: 'none',
      padding: '6px 12px',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '12px',
    },
    deleteBtn: {
      backgroundColor: '#e53e3e',
      color: 'white',
      border: 'none',
      padding: '6px 12px',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '12px',
    },
    modal: {
      display: 'fixed',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modalContent: {
      backgroundColor: 'white',
      padding: '30px',
      borderRadius: '8px',
      maxWidth: '500px',
      width: '90%',
      maxHeight: '90vh',
      overflowY: 'auto',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
    },
    modalHeader: {
      fontSize: '20px',
      fontWeight: 'bold',
      marginBottom: '20px',
      color: '#1a365d',
    },
    formGroup: {
      marginBottom: '15px',
    },
    label: {
      display: 'block',
      marginBottom: '5px',
      fontWeight: '500',
      color: '#1a365d',
      fontSize: '14px',
    },
    input: {
      width: '100%',
      padding: '10px',
      border: '1px solid #cbd5e0',
      borderRadius: '4px',
      fontSize: '14px',
      boxSizing: 'border-box',
      fontFamily: 'inherit',
    },
    select: {
      width: '100%',
      padding: '10px',
      border: '1px solid #cbd5e0',
      borderRadius: '4px',
      fontSize: '14px',
      boxSizing: 'border-box',
      fontFamily: 'inherit',
    },
    textarea: {
      width: '100%',
      padding: '10px',
      border: '1px solid #cbd5e0',
      borderRadius: '4px',
      fontSize: '14px',
      boxSizing: 'border-box',
      fontFamily: 'inherit',
      minHeight: '80px',
      resize: 'vertical',
    },
    checkbox: {
      marginRight: '8px',
      cursor: 'pointer',
    },
    modalButtons: {
      display: 'flex',
      gap: '10px',
      marginTop: '25px',
      justifyContent: 'flex-end',
    },
    saveBtn: {
      backgroundColor: '#2b6cb0',
      color: 'white',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
    },
    cancelBtn: {
      backgroundColor: '#cbd5e0',
      color: '#1a365d',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '14px',
    },
    filterInput: {
      marginBottom: '15px',
      padding: '10px',
      border: '1px solid #cbd5e0',
      borderRadius: '4px',
      fontSize: '14px',
      width: '100%',
      boxSizing: 'border-box',
    },
    errorMsg: {
      backgroundColor: '#fed7d7',
      color: '#c53030',
      padding: '12px',
      borderRadius: '4px',
      marginBottom: '15px',
      fontSize: '14px',
    },
    loadingSpinner: {
      textAlign: 'center',
      padding: '20px',
      color: '#4a5568',
    },
    searchBox: {
      display: 'flex',
      gap: '10px',
      marginBottom: '15px',
    },
    searchInput: {
      flex: 1,
      padding: '10px',
      border: '1px solid #cbd5e0',
      borderRadius: '4px',
      fontSize: '14px',
      boxSizing: 'border-box',
    },
    searchBtn: {
      backgroundColor: '#2b6cb0',
      color: 'white',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '14px',
    },
    resultCard: {
      backgroundColor: 'white',
      padding: '15px',
      borderRadius: '4px',
      marginBottom: '10px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    },
    resultTitle: {
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#1a365d',
      marginBottom: '5px',
    },
    resultText: {
      fontSize: '14px',
      color: '#4a5568',
      lineHeight: '1.5',
    },
  };

  // ==================== RENDER ====================

  const filteredClients = clients.filter(c =>
    `${c.firstName} ${c.lastName}`.toLowerCase().includes(clientFilter.toLowerCase()) ||
    c.email.toLowerCase().includes(clientFilter.toLowerCase())
  );

  const filteredCases = cases.filter(c =>
    c.title.toLowerCase().includes(caseFilter.toLowerCase()) ||
    c.caseNumber?.toLowerCase().includes(caseFilter.toLowerCase())
  );

  return (
    <div style={styles.container}>
      {/* Trial Banner */}
      {isTrial && (
      <div style={styles.trialBanner}>
        <div style={styles.trialText}>
          Δοκιμαστική περίοδος: {trialDays} ημέρες απομένουν | Αναβάθμιση στην Πλήρη Έκδοση - 29€/μήνα
        </div>
        <button style={styles.upgradeBtn} onClick={() => setShowTrialUpgrade(true)}>
          Αναβάθμιση τώρα
        </button>
      </div>
      )}

      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerTitle}>
          <img src="https://customer-assets.emergentagent.com/job_ailegalpro/artifacts/wofbxh36_Untitled%20design%20%2821%29.png" alt="Logo" style={{height:38}} />
          NOMOKRATIA.AI
        </div>
        <button style={styles.logoutBtn} onClick={handleLogout}>
          Αποσύνδεση
        </button>
      </div>

      {/* Error Message */}
      {error && <div style={styles.errorMsg}>{error}</div>}

      {/* Tab Bar */}
      <div style={styles.tabBar}>
        {[
          { id: 'nomologia', label: 'Νομολογία' },
          { id: 'syntaxi', label: '✍️ Σύνταξη' },
          { id: 'dashboard', label: 'Πίνακας Ελέγχου' },
          { id: 'clients', label: 'Πελάτες' },
          { id: 'cases', label: 'Υποθέσεις' },
          { id: 'deadlines', label: 'Προθεσμίες' },
          { id: 'hours', label: 'Ώρες' },
          { id: 'invoices', label: 'Τιμολόγια' },
          { id: 'aade', label: 'AADE' },
          { id: 'documents', label: 'Έγγραφα' },
          { id: 'conflicts', label: 'Σύγκρουση' },
          { id: 'ai', label: 'AI Insights' },
          { id: 'import', label: 'Εισαγωγή' },
        ].filter(t => !premiumTabs.includes(t.id) || isPremium).map(t => (
          <div
            key={t.id}
            style={{
              ...styles.tab,
              ...(activeTab === t.id ? styles.tabActive : {}),
            }}
            onClick={() => {
              if (premiumTabs.includes(t.id) && !isPremium) {
                setShowTrialUpgrade(true);
                return;
              }
              setActiveTab(t.id);
            }}
          >
            {t.label}{premiumTabs.includes(t.id) && !isPremium ? ' 🔒' : ''}
          </div>
        ))}
      </div>

      {/* Content */}
      <div style={styles.content}>
        {loading && !showClientModal && !showCaseModal && !showDeadlineModal && !showHourModal && !showInvoiceModal && !showDocumentModal && (
          <div style={styles.loadingSpinner}>Φόρτωση...</div>
        )}

        {/* Dashboard Tab */}
        {activeTab === 'dashboard' && !loading && (
          <div>
            <h2 style={{ marginBottom: '20px', color: '#1a365d' }}>Πίνακας Ελέγχου</h2>
            <div style={styles.statsGrid}>
              <div style={styles.statCard}>
                <div style={styles.statValue}>{stats.totalClients}</div>
                <div style={styles.statLabel}>Σύνολο Πελατών</div>
              </div>
              <div style={styles.statCard}>
                <div style={styles.statValue}>{stats.activeCases}</div>
                <div style={styles.statLabel}>Ενεργές Υποθέσεις</div>
              </div>
              <div style={styles.statCard}>
                <div style={styles.statValue}>{stats.upcomingDeadlines}</div>
                <div style={styles.statLabel}>Προθεσμίες Αυτό το Μήνα</div>
              </div>
              <div style={styles.statCard}>
                <div style={styles.statValue}>{stats.monthlyHours}</div>
                <div style={styles.statLabel}>Ώρες Αυτό το Μήνα</div>
              </div>
            </div>
          </div>
        )}

        {/* Clients Tab */}
        {activeTab === 'clients' && (
          <div>
            <h2 style={{ marginBottom: '15px', color: '#1a365d' }}>Πελάτες</h2>
            <input
              type="text"
              placeholder="Αναζήτηση πελατών..."
              value={clientFilter}
              onChange={e => setClientFilter(e.target.value)}
              style={styles.filterInput}
            />
            <button style={styles.actionBtn} onClick={() => openClientModal()} style={{ marginBottom: '15px', ...styles.actionBtn }}>
              + Νέος Πελάτης
            </button>
            {filteredClients.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '30px', color: '#4a5568' }}>
                Δεν υπάρχουν πελάτες
              </div>
            ) : (
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Όνομα</th>
                    <th style={styles.th}>Email</th>
                    <th style={styles.th}>Τηλέφωνο</th>
                    <th style={styles.th}>Εταιρεία</th>
                    <th style={styles.th}>ΑΦΛ</th>
                    <th style={styles.th}>Ενέργειες</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredClients.map(client => (
                    <tr key={client.id}>
                      <td style={styles.td}>{client.firstName} {client.lastName}</td>
                      <td style={styles.td}>{client.email}</td>
                      <td style={styles.td}>{client.phone}</td>
                      <td style={styles.td}>{client.company}</td>
                      <td style={styles.td}>{client.afl}</td>
                      <td style={styles.td}>
                        <div style={styles.actionCell}>
                          <button style={styles.editBtn} onClick={() => openClientModal(client)}>
                            Επεξεργασία
                          </button>
                          <button style={styles.deleteBtn} onClick={() => handleDeleteClient(client.id)}>
                            Διαγραφή
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {/* Cases Tab */}
        {activeTab === 'cases' && (
          <div>
            <h2 style={{ marginBottom: '15px', color: '#1a365d' }}>Υποθέσεις</h2>
            <input
              type="text"
              placeholder="Αναζήτηση υποθέσεων..."
              value={caseFilter}
              onChange={e => setCaseFilter(e.target.value)}
              style={styles.filterInput}
            />
            <button style={{ marginBottom: '15px', ...styles.actionBtn }} onClick={() => openCaseModal()}>
              + Νέα Υπόθεση
            </button>
            {filteredCases.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '30px', color: '#4a5568' }}>
                Δεν υπάρχουν υποθέσεις
              </div>
            ) : (
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Τίτλος</th>
                    <th style={styles.th}>Αρ. Υπόθεσης</th>
                    <th style={styles.th}>Τύπος</th>
                    <th style={styles.th}>Κατάσταση</th>
                    <th style={styles.th}>Πελάτης ID</th>
                    <th style={styles.th}>Ενέργειες</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCases.map(caseItem => (
                    <tr key={caseItem.id}>
                      <td style={styles.td}>{caseItem.title}</td>
                      <td style={styles.td}>{caseItem.caseNumber}</td>
                      <td style={styles.td}>{caseItem.caseType}</td>
                      <td style={styles.td}>{caseItem.status}</td>
                      <td style={styles.td}>{caseItem.clientId}</td>
                      <td style={styles.td}>
                        <div style={styles.actionCell}>
                          <button style={styles.editBtn} onClick={() => openCaseModal(caseItem)}>
                            Επεξεργασία
                          </button>
                          <button style={styles.deleteBtn} onClick={() => handleDeleteCase(caseItem.id)}>
                            Διαγραφή
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {/* Deadlines Tab */}
        {activeTab === 'deadlines' && (
          <div>
            <h2 style={{ marginBottom: '15px', color: '#1a365d' }}>Προθεσμίες</h2>
            <button style={{ marginBottom: '15px', ...styles.actionBtn }} onClick={() => openDeadlineModal()}>
              + Νέα Προθεσμία
            </button>
            {deadlines.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '30px', color: '#4a5568' }}>
                Δεν υπάρχουν προθεσμίες
              </div>
            ) : (
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Τίτλος</th>
                    <th style={styles.th}>Ημερομηνία Λήξης</th>
                    <th style={styles.th}>Προτεραιότητα</th>
                    <th style={styles.th}>Κατάσταση</th>
                    <th style={styles.th}>Υπόθεση ID</th>
                    <th style={styles.th}>Ενέργειες</th>
                  </tr>
                </thead>
                <tbody>
                  {deadlines.map(deadline => (
                    <tr key={deadline.id}>
                      <td style={styles.td}>{deadline.title}</td>
                      <td style={styles.td}>{deadline.dueDate}</td>
                      <td style={styles.td}>{deadline.priority}</td>
                      <td style={styles.td}>{deadline.status}</td>
                      <td style={styles.td}>{deadline.caseId}</td>
                      <td style={styles.td}>
                        <div style={styles.actionCell}>
                          <button style={styles.editBtn} onClick={() => openDeadlineModal(deadline)}>
                            Επεξεργασία
                          </button>
                          <button style={styles.deleteBtn} onClick={() => handleDeleteDeadline(deadline.id)}>
                            Διαγραφή
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {/* Hours Tab */}
        {activeTab === 'hours' && (
          <div>
            <h2 style={{ marginBottom: '15px', color: '#1a365d' }}>Καταγραφή Ωρών</h2>
            <button style={{ marginBottom: '15px', ...styles.actionBtn }} onClick={() => openHourModal()}>
              + Νέα Καταγραφή
            </button>
            {hours.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '30px', color: '#4a5568' }}>
                Δεν υπάρχουν καταγραφές ωρών
              </div>
            ) : (
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Ημερομηνία</th>
                    <th style={styles.th}>Ώρες</th>
                    <th style={styles.th}>Περιγραφή</th>
                    <th style={styles.th}>Χρεώσιμη</th>
                    <th style={styles.th}>Υπόθεση ID</th>
                    <th style={styles.th}>Ενέργειες</th>
                  </tr>
                </thead>
                <tbody>
                  {hours.map(hour => (
                    <tr key={hour.id}>
                      <td style={styles.td}>{hour.date}</td>
                      <td style={styles.td}>{hour.hours}</td>
                      <td style={styles.td}>{hour.description}</td>
                      <td style={styles.td}>{hour.billable ? 'Ναι' : 'Όχι'}</td>
                      <td style={styles.td}>{hour.caseId}</td>
                      <td style={styles.td}>
                        <div style={styles.actionCell}>
                          <button style={styles.editBtn} onClick={() => openHourModal(hour)}>
                            Επεξεργασία
                          </button>
                          <button style={styles.deleteBtn} onClick={() => handleDeleteHour(hour.id)}>
                            Διαγραφή
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {/* Invoices Tab */}
        {activeTab === 'invoices' && (
          <div>
            <h2 style={{ marginBottom: '15px', color: '#1a365d' }}>Τιμολόγια</h2>
            <button style={{ marginBottom: '15px', ...styles.actionBtn }} onClick={() => openInvoiceModal()}>
              + Νέο Τιμολόγιο
            </button>
            {invoices.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '30px', color: '#4a5568' }}>
                Δεν υπάρχουν τιμολόγια
              </div>
            ) : (
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Αριθμός</th>
                    <th style={styles.th}>Πελάτης</th>
                    <th style={styles.th}>Ποσό</th>
                    <th style={styles.th}>Ημερ. Λήξης</th>
                    <th style={styles.th}>Κατάσταση</th>
                    <th style={styles.th}>Ενέργειες</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices.map(invoice => (
                    <tr key={invoice.id}>
                      <td style={styles.td}>{invoice.invoiceNumber}</td>
                      <td style={styles.td}>{invoice.clientId}</td>
                      <td style={styles.td}>€{invoice.amount}</td>
                      <td style={styles.td}>{invoice.dueDate}</td>
                      <td style={styles.td}>{invoice.status}</td>
                      <td style={styles.td}>
                        <div style={styles.actionCell}>
                          <button style={styles.editBtn} onClick={() => openInvoiceModal(invoice)}>
                            Επεξεργασία
                          </button>
                          <button style={styles.deleteBtn} onClick={() => handleDeleteInvoice(invoice.id)}>
                            Διαγραφή
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {/* AADE Tab */}
        {activeTab === 'aade' && (
          <AADESettings onSave={(settings) => console.log('AADE settings saved:', settings)} />
        )}

        {/* Case Law (Nomologia) Tab */}
        {activeTab === 'nomologia' && (
          <LegalSearch />
        )}

        {/* Documents Tab */}
        {activeTab === 'documents' && (
          <DocGenerator />
        )}

        {/* Conflict Check Tab */}
        {activeTab === 'conflicts' && (
          <ConflictCheck />
        )}

        {/* AI Insights Tab */}
        {activeTab === 'ai' && (
          <AIInsights />
        )}
        {activeTab === 'syntaxi' && (
          <Syntaxi token={token} />
        )}
        {activeTab === 'import' && (
          <DataImport />
        )}
      </div>


      {/* Pricing Modal */}
      {showTrialUpgrade && (
        <div style={styles.modal}>
          <div style={{...styles.modalContent, maxWidth:900, padding:0, borderRadius:12, overflowY:'auto'}}>
            <div style={{background:'linear-gradient(135deg, #1e3a5f, #2c5282)', padding:'24px 30px', color:'white'}}>
              <div style={{fontSize:22, fontWeight:'bold', marginBottom:4}}>Αναβάθμιση Πλάνου</div>
              <div style={{fontSize:14, opacity:0.8}}>Επιλέξτε το πλάνο που σας ταιριάζει</div>
            </div>
            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:20, padding:30}}>
              {/* Plan 1: Free Trial */}
              <div style={{border:'2px solid #e2e8f0', borderRadius:10, padding:24, textAlign:'center'}}>
                <div style={{fontSize:18, fontWeight:'bold', color:'#1a365d', marginBottom:8}}>Δοκιμαστικό</div>
                <div style={{fontSize:32, fontWeight:'bold', color:'#1a365d', marginBottom:4}}>Δωρεάν</div>
                <div style={{fontSize:13, color:'#718096', marginBottom:16}}>14 ημέρες δωρεάν δοκιμή</div>
                <div style={{textAlign:'left', fontSize:13, color:'#4a5568', lineHeight:'2'}}>
                  ✔ Νομολογία (AI Αναζήτηση)<br/>
                  ✔ ✍️ Σύνταξη εγγράφων<br/>
                  ✔ Έγγραφα<br/>
                  ✔ AI Insights<br/>
                  ✔ Έως 10 χρήσεις AI<br/>
                  ✔ Χωρίς κάρτα
                </div>
                <div style={{marginTop:16, padding:'10px 20px', border:'1px solid #1e3a5f', borderRadius:8, color:'#1e3a5f', fontWeight:'600', fontSize:14}}>Τρέχον Πλάνο</div>
              </div>
              {/* Plan 2: Professional */}
              <div style={{border:'2px solid #1e3a5f', borderRadius:10, padding:24, textAlign:'center', position:'relative', boxShadow:'0 4px 12px rgba(0,0,0,0.1)'}}>
                <div style={{position:'absolute', top:-12, left:'50%', transform:'translateX(-50%)', backgroundColor:'#1e3a5f', color:'white', padding:'3px 14px', borderRadius:20, fontSize:12, fontWeight:'bold'}}>Δημοφιλές</div>
                <div style={{fontSize:18, fontWeight:'bold', color:'#1a365d', marginBottom:8}}>Επαγγελματικό</div>
                <div style={{fontSize:32, fontWeight:'bold', color:'#1a365d', marginBottom:4}}>€29<span style={{fontSize:16, fontWeight:'normal', color:'#718096'}}>/μήνα</span></div>
                <div style={{fontSize:13, color:'#718096', marginBottom:16}}>Για δικηγόρους</div>
                <div style={{textAlign:'left', fontSize:13, color:'#4a5568', lineHeight:'2'}}>
                  ✔ Νομολογία — απεριόριστα<br/>
                  ✔ ✍️ Σύνταξη — απεριόριστα<br/>
                  ✔ Έγγραφα<br/>
                  ✔ AI Insights<br/>
                  
                  ✔ Email Υποστήριξη
                </div>
                <button onClick={async () => {
                  const token = localStorage.getItem('token') || localStorage.getItem('nomokratia_token');
                  const doCheckout = async () => {
                    const res = await fetch('/api/stripe/create-checkout', { method:'POST', headers:{'Authorization':'Bearer '+token,'Content-Type':'application/json'}, body: JSON.stringify({plan:'basic'}) });
                    const data = await res.json();
                    if (res.status === 422 && (data.detail === 'vat_required' || (data.detail && data.detail.error))) {
                      const billing = await window.__nkBillingModal();
                      if (!billing) return; // abgebrochen
                      const sv = await fetch('/api/stripe/set-billing', { method:'POST', headers:{'Authorization':'Bearer '+token,'Content-Type':'application/json'}, body: JSON.stringify(billing) });
                      if (!sv.ok) { alert('Σφάλμα αποθήκευσης στοιχείων.'); return; }
                      return doCheckout();
                    }
                    if (data.checkout_url) window.location.href = data.checkout_url;
                    else alert(data.detail || 'Σφάλμα πληρωμής');
                  };
                  try { await doCheckout(); } catch(e) { alert('Σφάλμα σύνδεσης'); }
                }} style={{marginTop:16, padding:'10px 20px', backgroundColor:'#1e3a5f', color:'white', border:'none', borderRadius:8, fontWeight:'600', fontSize:14, cursor:'pointer', width:'100%'}}>Επιλογή</button>
              </div>
              {/* Plan 3: Law Firm */}
              <div style={{border:'2px solid #e2e8f0', borderRadius:10, padding:24, textAlign:'center'}}>
                <div style={{fontSize:18, fontWeight:'bold', color:'#1a365d', marginBottom:8}}>Δικηγορικό Γραφείο</div>
                <div style={{fontSize:32, fontWeight:'bold', color:'#1a365d', marginBottom:4}}>Κατόπιν<span style={{fontSize:16, fontWeight:'normal', color:'#718096'}}> επικοιν.</span></div>
                <div style={{fontSize:13, color:'#718096', marginBottom:16}}>Από 2+ δικηγόρους</div>
                <div style={{textAlign:'left', fontSize:13, color:'#4a5568', lineHeight:'2'}}>
                  ✔ Όλα τα Επαγγελματικού<br/>
                  ✔ Πολλαπλοί χρήστες<br/>
                  
                  
                  ✔ Priority Support
                </div>
                <button onClick={() => window.open('mailto:info@nomokratia.ai?subject=Δικηγορικό Γραφείο', '_blank')} style={{marginTop:16, padding:'10px 20px', border:'1px solid #1e3a5f', borderRadius:8, color:'#1e3a5f', fontWeight:'600', fontSize:14, cursor:'pointer', width:'100%', backgroundColor:'white'}}>Επικοινωνία</button>
              </div>
            </div>
            <div style={{padding:'0 30px 20px', textAlign:'center'}}>
              <button onClick={() => setShowTrialUpgrade(false)} style={{padding:'10px 30px', border:'1px solid #cbd5e0', borderRadius:8, backgroundColor:'white', color:'#4a5568', cursor:'pointer', fontSize:14}}>Κλείσιμο</button>
            </div>
          </div>
        </div>
      )}

      {/* Client Modal */}
      {showClientModal && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <div style={styles.modalHeader}>
              {currentClient ? 'Επεξεργασία Πελάτη' : 'Νέος Πελάτης'}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Όνομα</label>
              <input
                type="text"
                style={styles.input}
                value={clientForm.firstName}
                onChange={e => setClientForm({ ...clientForm, firstName: e.target.value })}
                placeholder="Όνομα"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Επώνυμο</label>
              <input
                type="text"
                style={styles.input}
                value={clientForm.lastName}
                onChange={e => setClientForm({ ...clientForm, lastName: e.target.value })}
                placeholder="Επώνυμο"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Email</label>
              <input
                type="email"
                style={styles.input}
                value={clientForm.email}
                onChange={e => setClientForm({ ...clientForm, email: e.target.value })}
                placeholder="email@example.com"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Τηλέφωνο</label>
              <input
                type="tel"
                style={styles.input}
                value={clientForm.phone}
                onChange={e => setClientForm({ ...clientForm, phone: e.target.value })}
                placeholder="+30 210 1234567"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Κινητό</label>
              <input type="tel" style={styles.input} value={clientForm.mobile} onChange={e => setClientForm({ ...clientForm, mobile: e.target.value })} placeholder="+30 69x xxxx xxx" />
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Εταιρεία</label>
                <input type="text" style={styles.input} value={clientForm.company} onChange={e => setClientForm({ ...clientForm, company: e.target.value })} placeholder="Όνομα Εταιρείας" />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Επάγγελμα</label>
                <input type="text" style={styles.input} value={clientForm.profession} onChange={e => setClientForm({ ...clientForm, profession: e.target.value })} placeholder="Επάγγελμα" />
              </div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              <div style={styles.formGroup}>
                <label style={styles.label}>ΑΦΜ</label>
                <input type="text" style={styles.input} value={clientForm.afm} onChange={e => setClientForm({ ...clientForm, afm: e.target.value })} placeholder="123456789" />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>ΑΜΚΑ</label>
                <input type="text" style={styles.input} value={clientForm.amka} onChange={e => setClientForm({ ...clientForm, amka: e.target.value })} placeholder="12345678901" />
              </div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              <div style={styles.formGroup}>
                <label style={styles.label}>ΔΟΥ</label>
                <input type="text" style={styles.input} value={clientForm.doy} onChange={e => setClientForm({ ...clientForm, doy: e.target.value })} placeholder="Δ.Ο.Υ." />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Αρ. Ταυτότητας</label>
                <input type="text" style={styles.input} value={clientForm.idNumber} onChange={e => setClientForm({ ...clientForm, idNumber: e.target.value })} placeholder="ΑΕ 123456" />
              </div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Ημ. Γέννησης</label>
                <input type="date" style={styles.input} value={clientForm.birthDate} onChange={e => setClientForm({ ...clientForm, birthDate: e.target.value })} />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Προηγ. Δικηγόρος</label>
                <input type="text" style={styles.input} value={clientForm.previousLawyer} onChange={e => setClientForm({ ...clientForm, previousLawyer: e.target.value })} placeholder="Όνομα προηγ. δικηγόρου" />
              </div>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Διεύθυνση</label>
              <input type="text" style={styles.input} value={clientForm.address} onChange={e => setClientForm({ ...clientForm, address: e.target.value })} placeholder="Οδός & Αριθμός" />
            </div>
            <div style={{display:'grid',gridTemplateColumns:'2fr 1fr',gap:12}}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Πόλη</label>
                <input type="text" style={styles.input} value={clientForm.city} onChange={e => setClientForm({ ...clientForm, city: e.target.value })} placeholder="Πόλη" />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Τ.Κ.</label>
                <input type="text" style={styles.input} value={clientForm.zip} onChange={e => setClientForm({ ...clientForm, zip: e.target.value })} placeholder="12345" />
              </div>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Πηγή Σύστασης</label>
              <input type="text" style={styles.input} value={clientForm.referralSource} onChange={e => setClientForm({ ...clientForm, referralSource: e.target.value })} placeholder="Πώς σας βρήκε;" />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Σημειώσεις</label>
              <textarea style={{...styles.input, minHeight:60, resize:'vertical'}} value={clientForm.notes} onChange={e => setClientForm({ ...clientForm, notes: e.target.value })} placeholder="Πρόσθετες σημειώσεις..." />
            </div>
            <div style={styles.modalButtons}>
              <button style={styles.cancelBtn} onClick={() => setShowClientModal(false)}>
                Άκυρο
              </button>
              <button style={styles.saveBtn} onClick={handleSaveClient} disabled={loading}>
                {loading ? 'Αποθήκευση...' : 'Αποθήκευση'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Case Modal */}
      {showCaseModal && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <div style={styles.modalHeader}>
              {currentCase ? 'Επεξεργασία Υπόθεσης' : 'Νέα Υπόθεση'}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Τίτλος</label>
              <input
                type="text"
                style={styles.input}
                value={caseForm.title}
                onChange={e => setCaseForm({ ...caseForm, title: e.target.value })}
                placeholder="Τίτλος Υπόθεσης"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Αριθμός Υπόθεσης</label>
              <input
                type="text"
                style={styles.input}
                value={caseForm.caseNumber}
                onChange={e => setCaseForm({ ...caseForm, caseNumber: e.target.value })}
                placeholder="π.χ. 1234/2024"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Τύπος Υπόθεσης</label>
              <select
                style={styles.select}
                value={caseForm.caseType}
                onChange={e => setCaseForm({ ...caseForm, caseType: e.target.value })}
              >
                <option value="">Επιλέξτε τύπο</option>
                <option value="civil">Αστική</option>
                <option value="criminal">Ποινική</option>
                <option value="commercial">Εμπορική</option>
                <option value="labor">Εργατική</option>
                <option value="administrative">Διοικητική</option>
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Πελάτης</label>
              <select style={styles.select} value={caseForm.clientId} onChange={e => setCaseForm({ ...caseForm, clientId: e.target.value })}>
                <option value="">Επιλέξτε πελάτη</option>
                {clients.map(c => <option key={c.id} value={c.id}>{c.firstName} {c.lastName}</option>)}
              </select>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Αρ. Πρωτοκόλλου</label>
              <input type="text" style={styles.input} value={caseForm.protocolNumber} onChange={e => setCaseForm({ ...caseForm, protocolNumber: e.target.value })} placeholder="Αριθμός Πρωτοκόλλου" />
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Αντίδικος</label>
                <input type="text" style={styles.input} value={caseForm.opponentName} onChange={e => setCaseForm({ ...caseForm, opponentName: e.target.value })} placeholder="Όνομα Αντιδίκου" />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>ΑΦΜ Αντιδίκου</label>
                <input type="text" style={styles.input} value={caseForm.opponentAfm} onChange={e => setCaseForm({ ...caseForm, opponentAfm: e.target.value })} placeholder="ΑΦΜ" />
              </div>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Δικηγόρος Αντιδίκου</label>
              <input type="text" style={styles.input} value={caseForm.opponentLawyer} onChange={e => setCaseForm({ ...caseForm, opponentLawyer: e.target.value })} placeholder="Όνομα Δικηγόρου" />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Δικαστήριο</label>
              <select style={styles.select} value={caseForm.court} onChange={e => setCaseForm({ ...caseForm, court: e.target.value })}>
                <option value="">Επιλέξτε Δικαστήριο</option>
                <option value="Ειρηνοδικείο">Ειρηνοδικείο</option>
                <option value="Πρωτοδικείο">Πρωτοδικείο</option>
                <option value="Εφετείο">Εφετείο</option>
                <option value="Άρειος Πάγος">Άρειος Πάγος</option>
                <option value="Διοικητικό Πρωτοδικείο">Διοικητικό Πρωτοδικείο</option>
                <option value="Συμβούλιο Επικρατείας">Συμβούλιο Επικρατείας</option>
                <option value="Πτωχευτικό">Πτωχευτικό</option>
              </select>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Ημ. Κατάθεσης</label>
                <input type="date" style={styles.input} value={caseForm.filingDate} onChange={e => setCaseForm({ ...caseForm, filingDate: e.target.value })} />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Επόμενη Δικάσιμος</label>
                <input type="date" style={styles.input} value={caseForm.nextHearing} onChange={e => setCaseForm({ ...caseForm, nextHearing: e.target.value })} />
              </div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Αξία Αντικειμένου (€)</label>
                <input type="number" style={styles.input} value={caseForm.disputeValue} onChange={e => setCaseForm({ ...caseForm, disputeValue: e.target.value })} placeholder="0.00" />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Αμοιβή (€)</label>
                <input type="number" style={styles.input} value={caseForm.fee} onChange={e => setCaseForm({ ...caseForm, fee: e.target.value })} placeholder="0.00" />
              </div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Τρόπος Χρέωσης</label>
                <select style={styles.select} value={caseForm.billingType} onChange={e => setCaseForm({ ...caseForm, billingType: e.target.value })}>
                  <option value="fixed">Παγία Αμοιβή</option>
                  <option value="hourly">Ωριαία</option>
                  <option value="percentage">Ποσοστό %</option>
                  <option value="success">Επιτυχίας (Success Fee)</option>
                </select>
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Προτεραιότητα</label>
                <select style={styles.select} value={caseForm.priority} onChange={e => setCaseForm({ ...caseForm, priority: e.target.value })}>
                  <option value="low">Χαμηλή</option>
                  <option value="normal">Κανονική</option>
                  <option value="high">Υψηλή</option>
                  <option value="urgent">Επείγουσα</option>
                </select>
              </div>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Κατάσταση</label>
              <select style={styles.select} value={caseForm.status} onChange={e => setCaseForm({ ...caseForm, status: e.target.value })}>
                <option value="Open">Ανοικτή</option>
                <option value="In Progress">Σε Εξέλιξη</option>
                <option value="Hearing">Σε Δικάσιμο</option>
                <option value="Appeal">Έφεση</option>
                <option value="Won">Κερδημένη</option>
                <option value="Lost">Χαμένη</option>
                <option value="Settled">Συμβιβασμός</option>
                <option value="Closed">Κλειστή</option>
                <option value="On Hold">Σε Αναμονή</option>
              </select>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Περιγραφή</label>
              <textarea style={{...styles.input, minHeight:60, resize:'vertical'}} value={caseForm.description} onChange={e => setCaseForm({ ...caseForm, description: e.target.value })} placeholder="Περιγραφή Υπόθεσης" />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Σημειώσεις</label>
              <textarea style={{...styles.input, minHeight:60, resize:'vertical'}} value={caseForm.notes} onChange={e => setCaseForm({ ...caseForm, notes: e.target.value })} placeholder="Πρόσθετες σημειώσεις..." />
            </div>
            <div style={styles.modalButtons}>
              <button style={styles.cancelBtn} onClick={() => setShowCaseModal(false)}>
                Άκυρο
              </button>
              <button style={styles.saveBtn} onClick={handleSaveCase} disabled={loading}>
                {loading ? 'Αποθήκευση...' : 'Αποθήκευση'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Deadline Modal */}
      {showDeadlineModal && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <div style={styles.modalHeader}>
              {currentDeadline ? 'Επεξεργασία Προθεσμίας' : 'Νέα Προθεσμία'}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Τίτλος</label>
              <input
                type="text"
                style={styles.input}
                value={deadlineForm.title}
                onChange={e => setDeadlineForm({ ...deadlineForm, title: e.target.value })}
                placeholder="Τίτλος Προθεσμίας"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Ημερομηνία Λήξης</label>
              <input
                type="date"
                style={styles.input}
                value={deadlineForm.dueDate}
                onChange={e => setDeadlineForm({ ...deadlineForm, dueDate: e.target.value })}
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Υπόθεση</label>
              <select style={styles.select} value={deadlineForm.caseId} onChange={e => setDeadlineForm({ ...deadlineForm, caseId: e.target.value })}>
                <option value="">Επιλέξτε υπόθεση</option>
                {cases.map(c => <option key={c.id} value={c.id}>{c.caseNumber || c.title}</option>)}
              </select>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Τύπος Προθεσμίας</label>
              <select style={styles.select} value={deadlineForm.deadlineType} onChange={e => setDeadlineForm({ ...deadlineForm, deadlineType: e.target.value })}>
                <option value="">Επιλέξτε τύπο</option>
                <option value="hearing">Δικάσιμος</option>
                <option value="filing">Κατάθεση</option>
                <option value="appeal">Προσφυγή</option>
                <option value="objection">Ένσταση</option>
                <option value="postponement">Αναβολή</option>
                <option value="payment">Πληρωμή</option>
                <option value="response">Απάντηση</option>
                <option value="other">Άλλο</option>
              </select>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Ώρα</label>
                <input type="time" style={styles.input} value={deadlineForm.dueTime} onChange={e => setDeadlineForm({ ...deadlineForm, dueTime: e.target.value })} />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Δικαστήριο</label>
                <select style={styles.select} value={deadlineForm.court} onChange={e => setDeadlineForm({ ...deadlineForm, court: e.target.value })}>
                  <option value="">Επιλέξτε</option>
                  <option value="Ειρηνοδικείο">Ειρηνοδικείο</option>
                  <option value="Πρωτοδικείο">Πρωτοδικείο</option>
                  <option value="Εφετείο">Εφετείο</option>
                  <option value="Άρειος Πάγος">Άρειος Πάγος</option>
                  <option value="Διοικητικό">Διοικητικό</option>
                  <option value="ΣτΕ">ΣτΕ</option>
                </select>
              </div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Προτεραιότητα</label>
                <select style={styles.select} value={deadlineForm.priority} onChange={e => setDeadlineForm({ ...deadlineForm, priority: e.target.value })}>
                  <option value="Low">Χαμηλή</option>
                  <option value="Normal">Κανονική</option>
                  <option value="High">Υψηλή</option>
                  <option value="Critical">Κρίσιμη</option>
                </select>
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Υπενθύμιση</label>
                <select style={styles.select} value={deadlineForm.reminder} onChange={e => setDeadlineForm({ ...deadlineForm, reminder: e.target.value })}>
                  <option value="1day">1 ημέρα πριν</option>
                  <option value="3days">3 ημέρες πριν</option>
                  <option value="1week">1 εβδομάδα πριν</option>
                  <option value="2weeks">2 εβδομάδες πριν</option>
                </select>
              </div>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Κατάσταση</label>
              <select style={styles.select} value={deadlineForm.status} onChange={e => setDeadlineForm({ ...deadlineForm, status: e.target.value })}>
                <option value="Pending">Εκκρεμής</option>
                <option value="Completed">Ολοκληρωμένη</option>
                <option value="Overdue">Καθυστερημένη</option>
                <option value="Cancelled">Ακυρωμένη</option>
              </select>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Περιγραφή</label>
              <textarea style={{...styles.input, minHeight:60, resize:'vertical'}} value={deadlineForm.description} onChange={e => setDeadlineForm({ ...deadlineForm, description: e.target.value })} placeholder="Περιγραφή Προθεσμίας" />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Σημειώσεις</label>
              <textarea style={{...styles.input, minHeight:60, resize:'vertical'}} value={deadlineForm.notes} onChange={e => setDeadlineForm({ ...deadlineForm, notes: e.target.value })} placeholder="Πρόσθετες σημειώσεις..." />
            </div>
            <div style={styles.modalButtons}>
              <button style={styles.cancelBtn} onClick={() => setShowDeadlineModal(false)}>
                Άκυρο
              </button>
              <button style={styles.saveBtn} onClick={handleSaveDeadline} disabled={loading}>
                {loading ? 'Αποθήκευση...' : 'Αποθήκευση'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Hour Modal */}
      {showHourModal && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <div style={styles.modalHeader}>
              {currentHour ? 'Επεξεργασία Καταγραφής' : 'Νέα Καταγραφή Ωρών'}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Υπόθεση</label>
              <select style={styles.select} value={hourForm.caseId} onChange={e => setHourForm({ ...hourForm, caseId: e.target.value })}>
                <option value="">Επιλέξτε υπόθεση</option>
                {cases.map(c => <option key={c.id} value={c.id}>{c.caseNumber || c.title}</option>)}
              </select>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Πελάτης</label>
              <select style={styles.select} value={hourForm.clientId} onChange={e => setHourForm({ ...hourForm, clientId: e.target.value })}>
                <option value="">Επιλέξτε πελάτη</option>
                {clients.map(c => <option key={c.id} value={c.id}>{c.firstName} {c.lastName}</option>)}
              </select>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Ημερομηνία</label>
              <input type="date" style={styles.input} value={hourForm.date} onChange={e => setHourForm({ ...hourForm, date: e.target.value })} />
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12}}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Από</label>
                <input type="time" style={styles.input} value={hourForm.startTime} onChange={e => setHourForm({ ...hourForm, startTime: e.target.value })} />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Έως</label>
                <input type="time" style={styles.input} value={hourForm.endTime} onChange={e => setHourForm({ ...hourForm, endTime: e.target.value })} />
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Ώρες</label>
                <input type="number" step="0.25" style={styles.input} value={hourForm.hours} onChange={e => setHourForm({ ...hourForm, hours: e.target.value })} placeholder="0.00" />
              </div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Είδος Εργασίας</label>
                <select style={styles.select} value={hourForm.activityType} onChange={e => setHourForm({ ...hourForm, activityType: e.target.value })}>
                  <option value="">Επιλέξτε</option>
                  <option value="consultation">Συμβουλευτική</option>
                  <option value="court">Παράσταση σε Δικαστήριο</option>
                  <option value="drafting">Σύνταξη Εγγράφου</option>
                  <option value="research">Νομική Έρευνα</option>
                  <option value="meeting">Συνάντηση Πελάτη</option>
                  <option value="phone">Τηλεφωνική Επικοινωνία</option>
                  <option value="email">Αλληλογραφία</option>
                  <option value="review">Αναθεώρηση Εγγράφων</option>
                  <option value="admin">Διοικητικά</option>
                  <option value="travel">Μετακίνηση</option>
                  <option value="other">Άλλο</option>
                </select>
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Ωριαία Χρέωση (€)</label>
                <input type="number" style={styles.input} value={hourForm.hourlyRate} onChange={e => setHourForm({ ...hourForm, hourlyRate: e.target.value })} placeholder="€/ώρα" />
              </div>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Περιγραφή Εργασίας</label>
              <textarea style={{...styles.input, minHeight:60, resize:'vertical'}} value={hourForm.description} onChange={e => setHourForm({ ...hourForm, description: e.target.value })} placeholder="Περιγράψτε την εργασία..." />
            </div>
            <div style={{display:'flex', alignItems:'center', gap:20}}>
              <label style={{display:'flex', alignItems:'center', gap:8, cursor:'pointer'}}>
                <input type="checkbox" checked={hourForm.billable} onChange={e => setHourForm({ ...hourForm, billable: e.target.checked })} />
                <span style={{fontSize:14, fontWeight:'500'}}>Χρεώσιμη</span>
              </label>
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Σημειώσεις</label>
              <textarea style={{...styles.input, minHeight:50, resize:'vertical'}} value={hourForm.notes} onChange={e => setHourForm({ ...hourForm, notes: e.target.value })} placeholder="Πρόσθετες σημειώσεις..." />
            </div>
            <div style={styles.modalButtons}>
              <button style={styles.cancelBtn} onClick={() => setShowHourModal(false)}>
                Άκυρο
              </button>
              <button style={styles.saveBtn} onClick={handleSaveHour} disabled={loading}>
                {loading ? 'Αποθήκευση...' : 'Αποθήκευση'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Invoice Modal */}
      {showInvoiceModal && (
        <React.Suspense fallback={<div>Loading...</div>}>
        <InvoiceCreator
          onClose={() => setShowInvoiceModal(false)}
          onSave={async (invoice) => {
            try {
              setLoading(true);
              const res = await fetch('/api/crm/invoices', {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify(invoice),
              });
              if (res.ok) {
                await fetchInvoices();
              }
            } catch(e) { console.error(e); }
            finally { setLoading(false); }
            setShowInvoiceModal(false);
          }}
        />
        </React.Suspense>
      )}

      {/* Document Modal */}
      {showDocumentModal && (
        <div style={styles.modal}>
          <div style={styles.modalContent}>
            <div style={styles.modalHeader}>Νέο Έγγραφο</div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Όνομα Εγγράφου</label>
              <input
                type="text"
                style={styles.input}
                value={documentForm.name}
                onChange={e => setDocumentForm({ ...documentForm, name: e.target.value })}
                placeholder="Όνομα εγγράφου"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>ID Υπόθεσης</label>
              <input
                type="text"
                style={styles.input}
                value={documentForm.caseId}
                onChange={e => setDocumentForm({ ...documentForm, caseId: e.target.value })}
                placeholder="ID Υπόθεσης"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Αρχείο</label>
              <input
                type="file"
                style={styles.input}
                onChange={e => setDocumentForm({ ...documentForm, file: e.target.files[0] })}
              />
            </div>

            <div style={styles.modalButtons}>
              <button style={styles.cancelBtn} onClick={() => setShowDocumentModal(false)}>
                Άκυρο
              </button>
              <button style={styles.saveBtn} onClick={handleSaveDocument} disabled={loading}>
                {loading ? 'Αποθήκευση...' : 'Αποθήκευση'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CRMDashboard;
